import React from 'react';
import qs from 'qs';
import {toast} from 'react-toastify';
import FileDownload from 'react-file-download';
import FileSaver from 'file-saver';
import { isIOS } from 'react-device-detect';
import irelandApi from '../irelandApi';
import store from '../store';
import {
  GET_PRODUCT_PAGE_PENDING,
  GET_PRODUCT_PAGE_FULFILLED,
  GET_PRODUCT_PAGE_REJECTED,
  GET_PRODUCT_PAGE_LOADING_MORE,
  GET_PRODUCT_PAGE_LOADED_MORE,
  PRODUCT_PAGE_SELECT_OUTLET,
  PRODUCT_PAGE_SELECT_CATEGORY,
  PRODUCT_PAGE_SELECT_NEW_PRODUCT,
  PRODUCT_PAGE_SELECT_BRAND,
  PRODUCT_PAGE_CLEAR_FILTERS,
  PRODUCT_PAGE_TURN_OFF_OBJECTIVE_FILTERS,
  PRODUCT_PAGE_SELECT_CLEAR_OBJECTIVE,
  PRODUCT_PAGE_SELECT_STOCK_IT_OBJECTIVE,
  PRODUCT_PAGE_SELECT_PRICE_IT_OBJECTIVE,
  PRODUCT_PAGE_SELECT_SELL_IT_OBJECTIVE,
} from '../reducers/productPageReducer';
import ToastMessage from '../components/common/toast-message';

export const TEAM_PRODUCTS_URL = '/api/product_pages';
export const TEAM_PRODUCTS_AVAILABLE_FILTER = '/api/product_pages/available_filters';

const buildQueryFromState = () => {
  const state = store.getState();
  const { filterBox } = state.productPage;
  return {
    special_stock_it: filterBox.specialStockIt,
    special_price_it: filterBox.specialPriceIt,
    special_sell_it: filterBox.specialSellIt,
    special_new: filterBox.specialNew,
    outlet_id: filterBox.selectedOutlet ? filterBox.selectedOutlet.value : null,
    category_ids: filterBox.categories.length > 0 ? filterBox.categories : null,
    brand_ids: filterBox.brands.length > 0 ? filterBox.brands : null,
  };
};

export const getProducts = (query, page = 1) => (dispatch) => {
  if (page === 1) {
    dispatch({type: GET_PRODUCT_PAGE_PENDING});
  } else {
    dispatch({type: GET_PRODUCT_PAGE_LOADING_MORE});
  }

  return irelandApi.get(`${TEAM_PRODUCTS_URL}?${qs.stringify({q: query, page}, {encodeValuesOnly: true, arrayFormat: 'brackets'})}`)
    .then((response) => {
      if (page === 1) {
        const {special} = response.data.meta.filter;
        if (!special['special-stock-it'] && !special['special-price-it'] && !special['special-sell-it']) {
          dispatch({type: PRODUCT_PAGE_TURN_OFF_OBJECTIVE_FILTERS});
        }
        dispatch({
          type: GET_PRODUCT_PAGE_FULFILLED,
          payLoad: response.data
        });
      } else {
        dispatch({
          type: GET_PRODUCT_PAGE_LOADED_MORE,
          payLoad: response.data
        });
      }
    })
    .catch((error) => {
      dispatch({
        type: GET_PRODUCT_PAGE_REJECTED,
        payLoad: error.data
      });
    });
};

const loadMoreItems = (page, size) => {
  store.dispatch(getProducts(buildQueryFromState(), page)).then(() => {
    const { products } = store.getState().productPage;
    if (products.length !== size) {
      loadMoreItems(page + 1, products.length);
    }
  });
};

export const getProductsPage = query => (dispatch) => {
  dispatch(getProducts(query, 1)).then(() => {
    const { products } = store.getState().productPage;
    loadMoreItems(2, products.length);
  });
};

export const getInitialProducts = () => (dispatch) => {
  irelandApi.get(TEAM_PRODUCTS_AVAILABLE_FILTER)
    .then((response) => {
      if (response.data.special_stock_it) {
        dispatch({type: PRODUCT_PAGE_SELECT_STOCK_IT_OBJECTIVE, payLoad: true});
      }
      return dispatch(getProductsPage(buildQueryFromState()));
    })
    .catch((error) => {
      dispatch({
        type: GET_PRODUCT_PAGE_REJECTED,
        payLoad: error.data
      });
    });
};

export const downloadProducts = () => () => irelandApi.get(
  `${TEAM_PRODUCTS_URL}?${qs.stringify({q: buildQueryFromState()}, {encodeValuesOnly: true, arrayFormat: 'brackets'})}`,
  {
    headers: {Accept: 'application/pdf'},
    responseType: 'blob'
  }
)
  .then((response) => {
    let filename = 'products.pdf';
    const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
    const matches = filenameRegex.exec(response.headers['content-disposition']);
    if (matches && matches[1]) {
      filename = matches[1].replace(/['"]/g, '');
    }
    if (isIOS) {
      FileSaver.saveAs(response.data, filename);
    } else {
      FileDownload(response.data, filename);
    }
  })
  .catch((error) => {
    toast.error(<ToastMessage
      iconStyle="error"
      message={`Products can not be downloaded: ${error.response.data.errors[0]}`}
    />);
  });

export const selectOutlet = outlet => (dispatch) => {
  dispatch({type: PRODUCT_PAGE_SELECT_OUTLET, payLoad: outlet});
  return dispatch(getProductsPage(buildQueryFromState()));
};

export const filterByObjective = objectives => (dispatch) => {
  if (objectives.length > 0) {
    [
      PRODUCT_PAGE_SELECT_STOCK_IT_OBJECTIVE,
      PRODUCT_PAGE_SELECT_PRICE_IT_OBJECTIVE,
      PRODUCT_PAGE_SELECT_SELL_IT_OBJECTIVE
    ].forEach(objective => dispatch({type: objective, payLoad: objectives.includes(objective)}));
  } else {
    dispatch({type: PRODUCT_PAGE_SELECT_CLEAR_OBJECTIVE});
  }

  return dispatch(getProductsPage(buildQueryFromState()));
};

export const filterByCategories = categories => (dispatch) => {
  dispatch({type: PRODUCT_PAGE_SELECT_CATEGORY, payLoad: categories});
  return dispatch(getProductsPage(buildQueryFromState()));
};

export const filterByBrands = brands => (dispatch) => {
  dispatch({type: PRODUCT_PAGE_SELECT_BRAND, payLoad: brands});
  return dispatch(getProductsPage(buildQueryFromState()));
};

export const filterByNewProduct = () => (dispatch) => {
  dispatch({type: PRODUCT_PAGE_SELECT_NEW_PRODUCT});
  return dispatch(getProductsPage(buildQueryFromState()));
};

export const clearFilters = () => (dispatch) => {
  dispatch({type: PRODUCT_PAGE_CLEAR_FILTERS});
  return dispatch(getProductsPage({}));
};

export const applyFilters = () => dispatch => dispatch(getProducts(buildQueryFromState()));



// WEBPACK FOOTER //
// ./src/actions/product-page.js